'use client';

import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/accordion';
import { FAQ_ITEMS, FAQ_COPY } from '@/lib/simple-setup/customer-wins';
import { SectLabel } from '@/components/landing/v4-shared';

export function SimpleSetupFaq() {
  return (
    <section className="relative" style={{ paddingTop: 112, paddingBottom: 112 }}>
      <div className="v4-sp-section-rule absolute top-0 inset-x-0" aria-hidden="true" />
      <div className="max-w-3xl mx-auto px-6">
        <div className="text-center mb-14">
          <div className="mb-5" style={{ display: 'inline-flex' }}>
            <SectLabel color="var(--cyan-glow)">{FAQ_COPY.eyebrow}</SectLabel>
          </div>
          <h2
            style={{
              fontFamily: 'var(--font-geist-sans)',
              fontSize: 'clamp(28px, 4.5vw, 56px)',
              fontWeight: 500,
              letterSpacing: '-0.025em',
              color: 'var(--paper)',
              lineHeight: 1.1,
              margin: 0,
            }}
          >
            {FAQ_COPY.heading}
          </h2>
        </div>

        <Accordion type="single" collapsible className="w-full">
          {FAQ_ITEMS.map((item, i) => (
            <AccordionItem
              key={item.q}
              value={`v4-sp-faq-${i}`}
              style={{ borderColor: 'var(--hair)' }}
            >
              <AccordionTrigger
                className="text-left hover:no-underline"
                style={{
                  fontFamily: 'var(--font-geist-sans)',
                  fontSize: 'clamp(15px, 1.8vw, 18px)',
                  color: 'var(--paper)',
                  fontWeight: 500,
                  paddingTop: 20,
                  paddingBottom: 20,
                }}
              >
                {item.q}
              </AccordionTrigger>
              <AccordionContent
                style={{
                  fontFamily: 'var(--font-geist-sans)',
                  fontSize: 'clamp(14px, 1.6vw, 16px)',
                  color: 'rgba(244,244,240,0.70)',
                  lineHeight: 1.6,
                  paddingBottom: 20,
                }}
              >
                {item.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
